import { useMemo } from "react";
import { ESCALATION_CATEGORY_INFO } from "@/lib/categoryInfo";
import { SCENARIOS } from "@/constants/testIds";

export function CategoryFilterBar({ category, onChange }) {
  const votableCategories = useMemo(
    () => Object.entries(ESCALATION_CATEGORY_INFO).filter(([, info]) => info.votable !== false),
    []
  );

  return (
    <div className="flex flex-wrap gap-2 mb-8" data-testid={SCENARIOS.categoryFilter}>
      <button
        onClick={() => onChange("")}
        className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase border transition-colors ${category === "" ? "bg-zinc-950 text-white border-zinc-950" : "text-zinc-500 border-zinc-300 hover:border-zinc-950"}`}
      >
        All
      </button>
      {votableCategories.map(([key, info]) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase border transition-colors ${category === key ? "bg-zinc-950 text-white border-zinc-950" : "text-zinc-500 border-zinc-300 hover:border-zinc-950"}`}
        >
          {info.label}
        </button>
      ))}
    </div>
  );
}
